import { SiteList } from '../config/portal';
export var getClientDomainProperty = function(clientPortalHostname, authPortalHostname, clientProperty) {
    var _SiteList_flatMap_find;
    return ((_SiteList_flatMap_find = SiteList.flatMap(function(portal) {
        return portal.domains;
    }).find(function(domain) {
        // We compare with client portal hostname if possible.
        // In the edge case clientPortalHostname is not available, use authPortalHostname as a fallback.
        // Edge case could be that auth portal was bookmarked and/or localstorage was cleared
        return domain.hostname === clientPortalHostname || domain.authHostname === authPortalHostname;
    })) === null || _SiteList_flatMap_find === void 0 ? void 0 : _SiteList_flatMap_find[clientProperty]) || null;
};
